var _rect, _path, _line, _line2, _path2, _line3, _line4, _path3, _rect2, _rect3, _line5, _line6, _rect4, _line7, _line8;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExampleTimeSpanControls(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 130,
    height: 65,
    viewBox: "0 0 130 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 129,
    height: 64,
    rx: 4.5,
    fill: "white",
    stroke: "#CFD3D3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M116.5 52.5H1V34.4032L7 31.9355L15 27L25 31.9355L35 34.4032L44 40.9839L53 38.5161L61.5 31.9355L69.5 34.4032L76.5 38.5161L83.5 34.4032L91 31.9355L97.5 34.4032H104.5H110L116.5 31.9355V52.5Z",
    fill: "#F2F2F2"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 40.5,
    y1: 13,
    x2: 40.5,
    y2: 52,
    stroke: "#E6E6E6"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 6.5,
    y1: 13,
    x2: 6.5,
    y2: 52,
    stroke: "#E6E6E6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M116.5 31.9355L110 34.4032H104.5H97.5L91 31.9355L83.5 34.4032L76.5 38.5161L69.5 34.4032L61.5 31.9355L53 38.5161L44 40.9839L35 34.4032L25 31.9355L15 27L7 31.9355L1 34.4032",
    stroke: "#6D6D6D"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 116,
    y1: 12.5,
    x2: 1,
    y2: 12.5,
    stroke: "#CCCCCC"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 1,
    y1: 52.5,
    x2: 74,
    y2: 52.5,
    stroke: "#E6E6E6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M47.6023 50V49.4886L49.5227 47.3864C49.7481 47.1402 49.9337 46.9261 50.0795 46.7443C50.2254 46.5606 50.3333 46.3883 50.4034 46.2273C50.4754 46.0644 50.5114 45.8939 50.5114 45.7159C50.5114 45.5114 50.4621 45.3343 50.3636 45.1847C50.267 45.035 50.1345 44.9195 49.9659 44.8381C49.7973 44.7566 49.608 44.7159 49.3977 44.7159C49.1742 44.7159 48.9792 44.7623 48.8125 44.8551C48.6477 44.946 48.5199 45.0739 48.429 45.2386C48.34 45.4034 48.2955 45.5966 48.2955 45.8182H47.625C47.625 45.4773 47.7036 45.178 47.8608 44.9205C48.018 44.6629 48.232 44.4621 48.5028 44.3182C48.7756 44.1742 49.0814 44.1023 49.4205 44.1023C49.7614 44.1023 50.0634 44.1742 50.3267 44.3182C50.59 44.4621 50.7964 44.6562 50.946 44.9006C51.0956 45.1449 51.1705 45.4167 51.1705 45.7159C51.1705 45.9299 51.1316 46.1392 51.054 46.3438C50.9782 46.5464 50.8456 46.7727 50.6562 47.0227C50.4688 47.2708 50.2083 47.5739 49.875 47.9318L48.5682 49.3295V49.375H51.2727V50H47.6023ZM54.3438 50.0795C53.9157 50.0795 53.5511 49.9631 53.25 49.7301C52.9489 49.4953 52.7188 49.1553 52.5597 48.7102C52.4006 48.2633 52.321 47.7235 52.321 47.0909C52.321 46.4621 52.4006 45.9252 52.5597 45.4801C52.7206 45.0331 52.9517 44.6922 53.2528 44.4574C53.5559 44.2206 53.9195 44.1023 54.3438 44.1023C54.768 44.1023 55.1307 44.2206 55.4318 44.4574C55.7348 44.6922 55.9659 45.0331 56.125 45.4801C56.286 45.9252 56.3665 46.4621 56.3665 47.0909C56.3665 47.7235 56.2869 48.2633 56.1278 48.7102C55.9688 49.1553 55.7386 49.4953 55.4375 49.7301C55.1364 49.9631 54.7718 50.0795 54.3438 50.0795ZM54.3438 49.4545C54.768 49.4545 55.0975 49.25 55.3324 48.8409C55.5672 48.4318 55.6847 47.8485 55.6847 47.0909C55.6847 46.5871 55.6307 46.1581 55.5227 45.804C55.4167 45.4498 55.2633 45.1799 55.0625 44.9943C54.8636 44.8087 54.6241 44.7159 54.3438 44.7159C53.9233 44.7159 53.5947 44.9233 53.358 45.3381C53.1212 45.7509 53.0028 46.3352 53.0028 47.0909C53.0028 47.5947 53.0559 48.0227 53.1619 48.375C53.268 48.7273 53.4205 48.9953 53.6193 49.179C53.8201 49.3627 54.0616 49.4545 54.3438 49.4545ZM57.446 50V49.4886L59.3665 47.3864C59.5919 47.1402 59.7775 46.9261 59.9233 46.7443C60.0691 46.5606 60.1771 46.3883 60.2472 46.2273C60.3191 46.0644 60.3551 45.8939 60.3551 45.7159C60.3551 45.5114 60.3059 45.3343 60.2074 45.1847C60.1108 45.035 59.9782 44.9195 59.8097 44.8381C59.6411 44.7566 59.4517 44.7159 59.2415 44.7159C59.018 44.7159 58.8229 44.7623 58.6562 44.8551C58.4915 44.946 58.3636 45.0739 58.2727 45.2386C58.1837 45.4034 58.1392 45.5966 58.1392 45.8182H57.4688C57.4688 45.4773 57.5473 45.178 57.7045 44.9205C57.8617 44.6629 58.0758 44.4621 58.3466 44.3182C58.6193 44.1742 58.9252 44.1023 59.2642 44.1023C59.6051 44.1023 59.9072 44.1742 60.1705 44.3182C60.4337 44.4621 60.6402 44.6562 60.7898 44.9006C60.9394 45.1449 61.0142 45.4167 61.0142 45.7159C61.0142 45.9299 60.9754 46.1392 60.8977 46.3438C60.822 46.5464 60.6894 46.7727 60.5 47.0227C60.3125 47.2708 60.0521 47.5739 59.7188 47.9318L58.4119 49.3295V49.375H61.1165V50H57.446ZM64.142 44.1023C64.3807 44.1042 64.6193 44.1496 64.858 44.2386C65.0966 44.3277 65.3144 44.4754 65.5114 44.6818C65.7083 44.8864 65.8665 45.1657 65.9858 45.5199C66.1051 45.8741 66.1648 46.3182 66.1648 46.8523C66.1648 47.3693 66.1155 47.8286 66.017 48.2301C65.9205 48.6297 65.7803 48.9669 65.5966 49.2415C65.4148 49.5161 65.1932 49.7244 64.9318 49.8665C64.6723 50.0085 64.3788 50.0795 64.0511 50.0795C63.7254 50.0795 63.4347 50.0152 63.179 49.8864C62.9252 49.7557 62.7169 49.5748 62.554 49.3438C62.393 49.1108 62.2898 48.8409 62.2443 48.5341H62.9375C63 48.8011 63.1241 49.0218 63.3097 49.196C63.4972 49.3684 63.7443 49.4545 64.0511 49.4545C64.5 49.4545 64.8542 49.2585 65.1136 48.8665C65.375 48.4744 65.5057 47.9205 65.5057 47.2045H65.4602C65.3542 47.3636 65.2282 47.5009 65.0824 47.6165C64.9366 47.732 64.7746 47.821 64.5966 47.8835C64.4186 47.946 64.2292 47.9773 64.0284 47.9773C63.6951 47.9773 63.3892 47.8949 63.1108 47.7301C62.8343 47.5634 62.6127 47.3352 62.446 47.0455C62.2812 46.7538 62.1989 46.4205 62.1989 46.0455C62.1989 45.6894 62.2784 45.3636 62.4375 45.0682C62.5985 44.7708 62.8239 44.5341 63.1136 44.358C63.4053 44.1818 63.7481 44.0966 64.142 44.1023ZM64.142 44.7273C63.9034 44.7273 63.6884 44.7869 63.4972 44.9062C63.3078 45.0237 63.1572 45.1828 63.0455 45.3835C62.9356 45.5824 62.8807 45.803 62.8807 46.0455C62.8807 46.2879 62.9337 46.5085 63.0398 46.7074C63.1477 46.9044 63.2945 47.0616 63.4801 47.179C63.6676 47.2945 63.8807 47.3523 64.1193 47.3523C64.2992 47.3523 64.4669 47.3172 64.6222 47.2472C64.7775 47.1752 64.9129 47.0777 65.0284 46.9545C65.1458 46.8295 65.2377 46.6884 65.304 46.5312C65.3703 46.3722 65.4034 46.2064 65.4034 46.0341C65.4034 45.8068 65.3485 45.5937 65.2386 45.3949C65.1307 45.196 64.9811 45.035 64.7898 44.9119C64.6004 44.7888 64.3845 44.7273 64.142 44.7273Z",
    fill: "#8D8D8D"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 74.5,
    y: 12.5,
    width: 42,
    height: 40,
    fill: "#D9D9D9",
    fillOpacity: 0.4,
    stroke: "#CCCCCC"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 70.5,
    y: 25.5,
    width: 8,
    height: 16,
    fill: "#F2F2F2",
    stroke: "#999999"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 73.5,
    y1: 29,
    x2: 73.5,
    y2: 38,
    stroke: "#999999"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 75.5,
    y1: 29,
    x2: 75.5,
    y2: 38,
    stroke: "#999999"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 112.5,
    y: 25.5,
    width: 8,
    height: 16,
    fill: "#F2F2F2",
    stroke: "#999999"
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 115.5,
    y1: 29,
    x2: 115.5,
    y2: 38,
    stroke: "#999999"
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 117.5,
    y1: 29,
    x2: 117.5,
    y2: 38,
    stroke: "#999999"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExampleTimeSpanControls);
export default __webpack_public_path__ + "static/media/exampleTimeSpanControls.bbee9ff502ebcc256a0f2e0f334549fa.svg";
export { ForwardRef as ReactComponent };